'use client'
import {ReactNode, useState} from "react";
import {DictionaryContext} from "@web-libs/core/internationalization/dictionary.context";
import {DictionaryEntries} from "@web-libs/core/internationalization/dictionary.types";


export const DictionaryProvider = ({children, dict}: { children: ReactNode, dict: DictionaryEntries }) => {

    return(
        <DictionaryContext.Provider value={dict}>
            {children}
        </DictionaryContext.Provider>
    )
}
